<ng-container [ngSwitch]="type">

    <!-- Template card skeleton -->
    <ng-container *ngSwitchCase="'template-card'">
        <div class="skel-template-card" *ngFor="let _ of items">
            <div class="skel-template-card__preview shimmer"></div>
            <div class="skel-template-card__info">
                <div class="skel-line shimmer" style="width: 65%; height: 14px;"></div>
                <div class="skel-line shimmer" style="width: 95%; height: 11px;"></div>
                <div class="skel-line shimmer" style="width: 80%; height: 11px;"></div>
            </div>
        </div>
    </ng-container>

    <!-- Project row skeleton -->
    <ng-container *ngSwitchCase="'project-row'">
        <div class="skel-project-row" *ngFor="let _ of items">
            <div class="skel-project-row__icon shimmer"></div>
            <div class="skel-project-row__info">
                <div class="skel-line shimmer" style="width: 60%; height: 13px;"></div>
                <div class="skel-line shimmer" style="width: 40%; height: 11px;"></div>
            </div>
            <div class="skel-project-row__badge shimmer"></div>
        </div>
    </ng-container>

    <!-- Stat card skeleton -->
    <ng-container *ngSwitchCase="'stat-card'">
        <div class="skel-stat-card" *ngFor="let _ of items">
            <div class="skel-stat-card__icon shimmer"></div>
            <div class="skel-stat-card__info">
                <div class="skel-line shimmer" style="width: 40%; height: 18px;"></div>
                <div class="skel-line shimmer" style="width: 60%; height: 11px;"></div>
            </div>
        </div>
    </ng-container>

    <!-- Generic rect -->
    <ng-container *ngSwitchCase="'rect'">
        <div class="skel-rect shimmer" *ngFor="let _ of items" [style.width]="width" [style.height]="height"></div>
    </ng-container>

    <!-- Text line -->
    <ng-container *ngSwitchCase="'text'">
        <div class="skel-line shimmer" *ngFor="let _ of items" [style.width]="width" [style.height]="height"></div>
    </ng-container>

</ng-container>
